<!-- 2022.11 宮ヶ瀬オンデマンドサービス時の実装 -->
<!-- エリアidやサービス期間外の表示など固定のため、再利用時には改修が必要 -->
<template>
  <div>
    <!-- 取得した予約可能なサービス一覧をループ表示 -->
    <div v-for="area in demandArea" :key="area.service_area_id">
      <!-- サービス名やサービス説明の外部URL -->
      <demandService :area="area" :isInServicePeriod="isInServicePeriod" />
      <!-- 予約するボタン -->
      <button v-if="area.service_area_id == 1082" @click="isEnabledOrder ? goToDemandBooking1(area) : null"
        class="do-resv">
        {{ isInServicePeriod ? '今すぐ呼ぶ' : '（現在はご利用いただけません）' }}
      </button>
      <button v-else class="do-resv">実証実験は終了しました。</button>
      <button v-if="area.service_area_id == 1082" @click="isInServicePeriod ?
        goToExternalLink(
          'https://passenger-app.ai-bus.jp/private/miyagase2nd1082/index.html'
        ) : null
      " class="do-resv" style="border-top: 1px solid #dfdfdf">
        {{ isInServicePeriod ? '日時を指定して予約する' : '（現在はご利用いただけません）' }}
      </button>

      <!-- 今までの予約した予約を羅列 -->
      <reservationsIndex v-if="isLogin" :Reservations="Reservations" :area="area" />
    </div>

    <!-- ローディングダイアログ -->
    <ItemDialog ref="loadingDialog" imageType="loader" :initialOpen="false" />

    <!-- 営業時間外に"予約する"を押した時の画面表示 -->
    <DialogNotOpenService ref="dialogNotOpenService" />
  </div>
</template>

<script>
import nativeHandlerService from "@/services/nativeHandler";
import { ref } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import API from "@/API";
import demandService from "@/services/demand";

export default {
  name: "TheDemandServiceIndexAndReservations",
  props: {
    demandArea: {
      type: Array,
      required: true,
    },
    Reservations: {
      type: Array,
      required: true,
    },
    anyValidReservation: {
      type: Number,
      required: true,
    },
  },
  setup(props) {
    // 「今すぐ呼ぶ」のみ、サービス開始前でもテスト期間中のみ有効にする必要がある
    // そのため、↓のisInServicePeriodとは別で管理する
    const isEnabledOrder = process.env.VUE_APP_DEMAND_ENABLED_ORDER == "true";

    // サービス開始前は利用不可の旨を表示&各リンク遷移を無効にする
    const isInServicePeriod = process.env.VUE_APP_DEMAND_IN_SERVICE_PERIOD == "true";

    const store = useStore();
    const router = useRouter();

    const loadingDialog = ref(null);
    const dialogNotOpenService = ref(null);

    const clearSelectedBusStop = () => {
      store.commit("demand/setPickupBusStop", { name: null, id: null });
      store.commit("demand/setDropoffBusStop", { name: null, id: null });
    };

    const setColumnWithDeparture = () => {
      store.commit("demand/setSelectedColumn", "Departure");
      nativeHandlerService.demand.ncSetSelectColumn("Departure");
    }

    const goToDemandBooking1 = async (area) => {
      const isLogin = store.getters["common/isLogin"];

      // 未ログインならアカウントページへ
      if (isLogin) {
        // E-バス・シャトルどちらかに有効な予約があればボタン押しても無アクション
        if (props.anyValidReservation == 0) {
          loadingDialog.value.open();

          // どのサービスを選択したかをネイティブへ
          nativeHandlerService.demand.ncSetBusMode(1);

          // BFF経由でWrapperトークン取得
          await API.getDemandToken(1);

          // Wrapperへ直接運行情報を取得
          area["info"] = await API.getEbusInfo(area.service_area_id);

          // 選択したサービス情報をstoreへ
          store.commit("demand/setSelectedService", area);

          // 選ばれたサービスの営業時間内かを検証
          if (
            demandService.isOpenForBusiness(
              area.info.operationStartTime,
              area.info.operationEndTime
            )
          ) {
            // 「今すぐ呼ぶ」押下時に選択されたバス停の情報をクリア&出発欄を選択状態にする。
            clearSelectedBusStop();
            setColumnWithDeparture();

            // ネイティブへ座標の送信
            nativeHandlerService.demand.ncSetPlaceInfoDemand(area);
            router.push({
              name: "DemandEbusBooking1",
            });
          } else {
            loadingDialog.value.close();
            // 時間外ならダイアログ表示
            dialogNotOpenService.value.openDialog();
          }
        }
      } else {
        nativeHandlerService.returnNativeAppToAccountPage();
      }
    };

    return {
      isEnabledOrder,
      isInServicePeriod,
      goToDemandBooking1,
      loadingDialog,
      dialogNotOpenService,
    };
  },
};
</script>
<style scoped lang="scss">
.do-resv {
  background: white;
  font-size: 1rem;
  padding: 15px 10px;
  width: 100%;
  border: none;
  text-align: left;
  color: black;
}
</style>
